/** Local storage keys */

export const USER_AUTH_INFO = 'user-auth-info'
export const APP_LANGUAGE = 'app-language'
export const SELECTED_PLAYER_QUALITY = 'selected-player-quality'
export const SELECTED_SUBTITLE_TRACK = 'selected-subtitle-track'
export const AUTO_PLAY_NEXT_EPISODE = 'autoplay-next-episode'
export const SELECTED_PROFILE = 'selected-profile'
export const GRAPHICS = 'graphics'
